export const CFDI4_PERSONS_TYPE = [
   { value: 'natural', viewValue: 'Persona Física' },
   { value: 'legalEntity', viewValue: 'Persona Moral' },
 ];
